import React from 'react';
import { useTranslation } from 'react-i18next';
import MobileEventElementContainer from 'site/pages/events/mobile-event-element-container';
import { buildEventViewModel } from 'stores/events/event-form-store';
import { EventDto } from 'stores/events/events-store';

interface EventListContainerProps {
  events: EventDto[];
  onEventClick: (event?: EventDto) => void;
}

const EventListContainer: React.FC<EventListContainerProps> = ({ events, onEventClick }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 p-2">
      {(events || []).length > 0 ? (
        (events || []).map((item, i) => (
          <MobileEventElementContainer
            key={i}
            event={buildEventViewModel(item)}
            selectedEvent={item}
            onClick={i => {
              onEventClick(i);
            }}
          />
        ))
      ) : (
        <div className="flex justify-center items-center p-4 text-gray-500">{t('No events available for selection')}.</div>
      )}
    </div>
  );
};

export default EventListContainer;
